import { render } from "./alurPelayanan.vue?vue&type=template&id=5cb0d5b0"
import script from "./alurPelayanan.vue?vue&type=script&lang=js"
export * from "./alurPelayanan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__